import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-zoo',
  templateUrl: './events-zoo.component.html',
  styleUrls: ['./events-zoo.component.scss'],
})
export class EventsZooComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/zoo/1.jpg',
      thumbnail: 'assets/img/school/events/zoo/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/zoo/2.jpg',
      thumbnail: 'assets/img/school/events/zoo/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/zoo/3.jpg',
      thumbnail: 'assets/img/school/events/zoo/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/zoo/4.jpg',
      thumbnail: 'assets/img/school/events/zoo/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/zoo/5.jpg',
      thumbnail: 'assets/img/school/events/zoo/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/zoo/6.jpg',
      thumbnail: 'assets/img/school/events/zoo/6.jpg',
      alt: 'Image 01',
    },
  ];
}
